var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"ops-wrapper offer-dashboard"},[_c('div',{staticClass:"animated fadeIn"},[_c('div',{staticClass:"ops container-custom"},[_c('posted-offers',{on:{"offerDetails":function($event){_vm.postedOfferId = $event}}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }